import React from 'react';
import { Star, Calendar } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { testimonials } from '../mockData';

const TestimonialsSection = () => {
  return (
    <section id="testimonios" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-golden/10 text-golden text-sm font-medium tracking-wider rounded-full mb-4">
            TESTIMONIOS
          </span>
          <h2 className="text-4xl sm:text-5xl font-serif font-light text-charcoal mb-6">
            Historias de Transformación
          </h2>
          <p className="text-lg text-charcoal/70 max-w-3xl mx-auto leading-relaxed">
            Miles de mujeres han transformado su vida financiera. Tú puedes ser la siguiente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id} 
              className="p-8 border-cream-dark hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-golden" size={16} fill="currentColor" />
                ))}
              </div>
              
              <p className="text-charcoal/80 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              
              <div className="flex items-center space-x-4 pt-4 border-t border-cream-dark">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <h4 className="font-medium text-charcoal">{testimonial.name}</h4>
                  <p className="text-sm text-charcoal/60">{testimonial.role}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 bg-gradient-to-r from-golden via-golden-light to-golden rounded-2xl p-8 sm:p-12 text-center">
          <h3 className="text-2xl sm:text-3xl font-serif text-white mb-4">
            ¿Lista para escribir tu propia historia de éxito?
          </h3>
          <p className="text-white/90 mb-8 max-w-2xl mx-auto">
            Únete a miles de mujeres que ya están construyendo su libertad financiera
          </p>
          <button 
            onClick={() => window.location.href = '/diagnostico'}
            className="bg-white text-golden hover:bg-cream px-8 py-4 rounded-lg font-medium shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Comienza con tu Diagnóstico Gratis
          </button>
        </div>

        {/* Calendly Booking Card */}
        <div className="mt-12 max-w-2xl mx-auto">
          <Card className="p-8 bg-gradient-to-br from-purple-50 to-pink-50 border-purple-200 shadow-lg">
            <div className="text-center">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Calendar className="text-purple-600" size={28} />
                <h3 className="text-xl font-serif text-charcoal">
                  ¿Quieres reservar una consultoría personalizada conmigo por 90 minutos?
                </h3>
              </div>
              <p className="text-charcoal/70 leading-relaxed mb-6">
                Agenda ahora por sólo <span className="font-bold text-purple-600">$97 USD</span> y con gusto te ayudaré a resolver tus dudas financieras de manera personalizada.
              </p>
              <Button
                onClick={() => window.open('https://calendly.karirojas.com', '_blank')}
                className="bg-gradient-to-r from-purple-600 to-pink-500 hover:from-purple-700 hover:to-pink-600 text-white px-8 py-5 text-base font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                data-testid="testimonials-calendly-btn"
              >
                <Calendar className="mr-2" size={18} />
                Revisar Disponibilidad
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
